import React from 'react';
import Module from 'Components/Core/Module';
import useBrokerageConnections from 'Components/Banking/useBrokerageConnections';
import BrokerageLoginForm from 'Components/Banking/BrokerageLoginForm';
import BrokerageOrderForm from 'Components/Banking/BrokerageOrderForm';
import './Brokerage.css';

const emptyOrder = (depotId) => ({ depotId, instrumentId: '', venueId: '', side: 'BUY', quantity: '', limitPrice: '' });

// Muss (wie ModuleTable es intern tut) in <Module> gewrappt werden - nur das
// registriert bei x.wam[id].show()/hide() die tatsaechliche Ein-/Ausblende-
// Logik beim Seitenwechsel. Ohne diesen Wrapper bleibt die Seite dauerhaft im
// DOM sichtbar und ueberlappt beim Navigieren mit anderen Modulen.
export default function BrokerageOrderbook(props) {

	const x = props.x;
	const connections = useBrokerageConnections(x);

	const [connectionId, setConnectionId] = React.useState(null);
	const [loggedIn, setLoggedIn] = React.useState(false);
	const [depots, setDepots] = React.useState(null);
	const [depotId, setDepotId] = React.useState(null);
	const [orders, setOrders] = React.useState(null);
	const [showOrderForm, setShowOrderForm] = React.useState(false);
	const [error, setError] = React.useState('');

	React.useEffect(() => {
		if (connectionId === null && connections && connections.length === 1) {
			setConnectionId(connections[0].connectionid);
		}
	}, [connections, connectionId]);

	function loadDepots() {
		x.was.axPost('Backend/webapp.php?module=Banking&task=BrokerageDepotList', { connectionId }, (result) => {
			const content = result.data.content || {};
			if (result.data.returncode !== 1) {
				if (content.status === 'login-required') {
					setLoggedIn(false);
					return;
				}
				setError(content.message || 'Depot konnte nicht geladen werden.');
				return;
			}
			const loaded = content.depots || [];
			setDepots(loaded);
			if (loaded.length === 1) setDepotId(loaded[0].depotId);
		});
	}

	function loadOrders() {
		x.was.axPost('Backend/webapp.php?module=Banking&task=BrokerageOrderList', { connectionId, depotId }, (result) => {
			const content = result.data.content || {};
			if (result.data.returncode !== 1) {
				if (content.status === 'login-required') {
					setLoggedIn(false);
					return;
				}
				setError(content.message || 'Orderbuch konnte nicht geladen werden.');
				return;
			}
			setOrders(content.orders || []);
		});
	}

	React.useEffect(() => {
		if (loggedIn) loadDepots();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [loggedIn]);

	React.useEffect(() => {
		if (loggedIn && depotId) loadOrders();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [loggedIn, depotId]);

	const connection = connections ? connections.find((c) => c.connectionid === connectionId) : null;

	let inner;
	if (connections === null) {
		inner = <p>Lade…</p>;
	} else if (connections.length === 0) {
		inner = <p>Keine comdirect-Verbindung vorhanden. Bitte zuerst unter Banking → Konten eine comdirect-Verbindung anlegen.</p>;
	} else if (connectionId === null) {
		inner = (
			<div className="brokerage-picker">
				{connections.map((c) => (
					<div key={c.connectionid} className="brokerage-picker-item" onClick={() => setConnectionId(c.connectionid)}>
						{c.bankname} – {c.accountlabel}
					</div>
				))}
			</div>
		);
	} else if (!loggedIn) {
		inner = (
			<BrokerageLoginForm
				x={x}
				connectionId={connectionId}
				accountLabel={connection ? connection.bankname + ' – ' + connection.accountlabel : ''}
				pinUse={true}
				pinStored={connection ? parseInt(connection.pinstored, 10) === 1 : false}
				onLoggedIn={() => setLoggedIn(true)}
			/>
		);
	} else if (depotId === null) {
		inner = (
			<React.Fragment>
				{error !== '' && <p className="brokerage-error"><i className="bi bi-exclamation-triangle"></i> {error}</p>}
				{depots === null && <p>Lade Depot…</p>}
				{depots !== null && depots.length === 0 && <p>Kein Depot gefunden.</p>}
				<div className="brokerage-picker">
					{(depots || []).map((depot) => (
						<div key={depot.depotId} className="brokerage-picker-item" onClick={() => setDepotId(depot.depotId)}>
							Depot {depot.depotDisplayId}
						</div>
					))}
				</div>
			</React.Fragment>
		);
	} else {
		inner = (
			<React.Fragment>
				{error !== '' && <p className="brokerage-error"><i className="bi bi-exclamation-triangle"></i> {error}</p>}
				{!showOrderForm &&
					<button type="button" className="btn" onClick={() => setShowOrderForm(true)}>Neue Order</button>
				}
				{showOrderForm &&
					<BrokerageOrderForm
						x={x}
						connectionId={connectionId}
						initialOrder={emptyOrder(depotId)}
						onCancel={() => setShowOrderForm(false)}
						onDone={() => { setShowOrderForm(false); loadOrders(); }}
					/>
				}
				{orders === null && <p>Lade Orderbuch…</p>}
				{orders !== null && orders.length === 0 && <p className="brokerage-hint">Keine offenen Orders.</p>}
				{(orders || []).map((order, idx) => (
					<div key={order.orderId || idx} className="brokerage-order-row">
						<span>{(order.instrument && (order.instrument.name || order.instrument.wkn)) || order.instrumentId || 'Order'}</span>
						<span>{order.side || ''} {order.quantity && order.quantity.value} @ {order.limit && order.limit.value}</span>
						<span>{order.status || ''}</span>
					</div>
				))}
			</React.Fragment>
		);
	}

	return (
		<Module id={props.id} x={x} classes="module-brokerage-orderbook" title={props.title} display="d-block">
			{inner}
		</Module>
	)

};
